import ScrollableContent from '../Scrolling/ScrollableContent';
import React from 'react';

export const ScrollTableHead = ({ colWidths, getData, children, ...props }) => {
    return (
        <div
            style={{
                display: 'flex',
                width: 'calc(100% - 22px)'
            }}
        >
            <table
                style={{
                    zIndex: 999,
                    backgroundColor: 'white',
                    borderCollapse: 'collapse',
                    height: props?.style?.height ? props.style.height : 400,
                    boxSizing: 'border-box',
                    padding: 0,
                    width: '100%'
                }}
            >
                <colgroup>
                    {colWidths?.map((a, b) => {
                        return b < colWidths.length ? (
                            <col key={'col' + b} width={a}></col>
                        ) : (
                            <></>
                        );
                    })}
                    <col width={20}></col>
                </colgroup>
                {getData ? getData() : children}
            </table>
        </div>
    );
};
export const ScrollTableBody = ({ colWidths, children, ...props }) => {
    return (
        <ScrollableContent
            relativeX={-22}
            style={{
                height: props?.style?.height ? props.style.height : 400,
                padding: 0,
                boxSizing: 'border-box',
                width: '100%',
                verticalAlign: 'top'
            }}
        >
            <table
                style={{
                    backgroundColor: 'white',
                    width: '100%',
                    borderCollapse: 'collapse'
                }}
            >
                <colgroup>
                    {colWidths?.map((a, b) => {
                        return <col key={'col' + b} width={a}></col>;
                    })}
                    <col width={20}></col>
                </colgroup>
                <tbody>{children}</tbody>
            </table>
        </ScrollableContent>
    );
};
export const ScrollTable = (props) => {
    const { style, colWidths, children } = props;
    return (
        <div
            style={{
                ...style,
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: 'white'
            }}
        >
            <div
                style={{
                    ...style,
                    width: style?.width ? style?.width : 400
                }}
            >
                {children.map((a, b) => {
                    return React.cloneElement(a, {
                        key: `scrollTableChild${b}`,
                        colWidths: colWidths
                    });
                })}
            </div>
        </div>
    );
};

export default ScrollTable;
